export * from './content-details';
